"use strict";
exports.__esModule = true;
exports.DWEB_STAGING_HOST = exports.DWEB_PROD_HOST = exports.getDWebHostName = exports.isProd = void 0;
var environment_1 = require("../environment");
function isProd() {
    return (0, environment_1.getAppEnvironment)().appBuild === "PROD";
}
exports.isProd = isProd;
function getDWebHostName() {
    return isProd() ? exports.DWEB_PROD_HOST : exports.DWEB_STAGING_HOST;
}
exports.getDWebHostName = getDWebHostName;
exports.DWEB_PROD_HOST = "https://web.snapchat.com";
exports.DWEB_STAGING_HOST = "https://staging-web-gcp.snap-dev.net";
//# sourceMappingURL=domain.js.map